export default "__VITE_ASSET__BNmw6kMz__"